
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8 2.7c-3 0-5.4 2.4-5.4 5.4 0 3 2.4 5.4 5.4 5.4 3 0 5.4-2.4 5.4-5.4 0-3-2.4-5.4-5.4-5.4zm0 9.8c-2.5 0-4.4-2-4.4-4.4 0-2.5 2-4.4 4.4-4.4 2.5 0 4.4 2 4.4 4.4 0 2.5-1.9 4.4-4.4 4.4z"}}),_c('path',{attrs:{"d":"M8.6 7.8l-.2-1.1c-.1-.3-.3-.5-.6-.4-.3.1-.5.3-.4.6l.3 1.3c0 .1.1.3.2.3l1.3 1c.2.2.5.1.7-.1.1-.2.1-.5-.1-.7l-1.2-.9z"}})])])
          )
        }
      }
    